export { WorkspaceEntrypoint } from './scope';
